/*
  "Passend dazu" je Variante
  --------------------------
  product-info.js tauscht beim Variantenwechsel nur Preis, SKU, Lieferhinweis,
  Mengenstaffel und Bilder aus. Dieser kleine Zusatz haengt sich an das bereits
  vorhandene Event "variantChange" und tauscht zusaetzlich den Block
  #CrossCell-<section.id> aus - damit greift die Vererbung
  Variante -> (falls leer) Produkt auch nach dem Umschalten.

  Danach wird der Swiper des Blocks neu initialisiert
  (initRelatedProductsSwiper stammt aus assets/dynamic.js).
*/
(function () {
  if (window.crossCellVariantReady) return;
  window.crossCellVariantReady = true;

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;
    if (!sectionId || !html) return;

    const source = html.getElementById(`CrossCell-${sectionId}`);
    if (!source) return;

    let updated = false;

    document.querySelectorAll('product-info').forEach((productInfo) => {
      const infoSectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
      if (infoSectionId !== sectionId) return;

      const destination = productInfo.querySelector('[id^="CrossCell-"]');
      if (!destination) return;

      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', source.classList.contains('hidden'));
      updated = true;
    });

    if (updated && typeof initRelatedProductsSwiper === 'function') {
      initRelatedProductsSwiper();
    }
  });
})();